import { toast } from "react-hot-toast";
import ErrorSound from "./error.mp3";

const errorSound = new Audio(ErrorSound);

const toasts = {
	success: (msg) => {
		toast.success(msg);
	},
	error: (msg) => {
		toast.error(msg);
		errorSound.play();
	},
	handleError: (err) => {
		const responseData = err?.response?.data;
		const fallbackMessage = err?.message || "Something went wrong";
		toast.error(responseData?.error || fallbackMessage);
		if (Array.isArray(responseData?.errors)) {
			responseData.errors.forEach((e) => {
				toast.error(e);
			});
		}
	},
	promise: (pendingPromise, msg, onSuccess, onError) => {
		toast.promise(pendingPromise, {
			loading: msg,
		});
	},
	loading: (msg) => {
		const toastId = toast.loading(msg);
		return () => toast.dismiss(toastId);
	},
};

export default toasts;
